import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-27/task-02";

const task: Slide = {
  titleHtml:
    "A sound-walk is a listening experiment where the participants are visiting different real<br>sound areas and answer question about e.g. their feelings. Consider a sound-walk and a<br>virtual sound-walk. What are the advantages of the different methods?",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
